var path = require('../internals/path');

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/entry-virtual.js
// module id = 38
// module chunks = 0 1